import React from 'react';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import BlockedSubscription from 'components/molecules/blocked_subscription';
import ConsultancyLegalList from 'components/organisms/consultancy_legal_list';

const ConsultancyLegal = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return (
    <div className="page-container py-4">
      {profile.paralyzed ? (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      ) : (
        <ConsultancyLegalList />
      )}
    </div>
  );
};
export default ConsultancyLegal;
